/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useGetPersonById = (idPerson) => useApi(
    `/v2/person/${idPerson}`,
    'GET',
    {},
    {},
    true
);

export const useGetPersonByLegalPersonId = () => useApi(
    `/v2/person/legal-person`,
    'GET',
    {},
    {},
    true
);

export const useGetPersonByLegalPersonIdAndOwner = () => useApi(
    `/v2/person/legal-person-owner`,
    'GET',
    {},
    {},
    true
);

export const useGetPersons = (query) => useApi(
    '/v2/person',
    'GET',
    {...query},
    {}
);

export const useGetPersonsSync = (query) => useApi(
    '/v2/person',
    'GET',
    {...query},
    {},
    true
);

export const useGetSicCode = (query) => useApi(
    '/v2/person/infos/sic-code',
    'GET',
    {...query},
    {},
    true
);

export const useGetCustomFilterList = (idDomain, idDomainApplication) => useApi(
    `/person/v2/filter/custom-filter/${idDomain}/${idDomainApplication}`,
    'GET',
    {},
    {},
    true
);

export const useSaveCustomFilters = (filterParams) => useApi(
    `/person/v2/filter/custom-filter`, 
    'POST', 
    {}, 
    { filterParams },
    true
);

export const useUpdateCustomFilters = (filterParams) => useApi(
    `/person/v2/filter/custom-filter`, 
    'PUT', 
    {}, 
    { filterParams },
    true
);

export const useDeleteCustomFilters = (filterParams) => useApi(
    `/person/v2/filter/custom-filter`, 
    'DELETE', 
    {}, 
    { filterParams },
    true
);

export const usePersonExpire  = (idPerson) => useApi(`v2/person/${idPerson}`, 'DELETE', {}, {}, true);

export const usePersonRestore  = (idPerson) => useApi(`v2/person/${idPerson}/restore`, 'PATCH', {}, {}, true);